<template>
  <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true" :showModalLoading="showModalLoading" :pathResource="pathResource" @refresh="onRefresh">
    <template slot="toolbar">
      <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoCausaleDocumento">
        <b-icon icon="plus"></b-icon>
        Nuovo
      </b-button>
    </template>
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Struttura</label>
            <b-form-select v-model="filtro.codiceStruttura" :value="null" @input="onChangeStruttura()">
              <template #first>
                <b-form-select-option :value="null"> - Tutte - </b-form-select-option>
              </template>
              <b-form-select-option v-for="tipoDoc in strutturaOptions" :key="tipoDoc.id" :value="tipoDoc.codiceStruttura"> {{ tipoDoc.denominazione }} ({{ tipoDoc.codiceStruttura }}) </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Tipo Documento</label>
            <b-form-select v-model="filtro.idTipoDocumento" :value="null">
              <template #first>
                <b-form-select-option :value="null"> - Tutte - </b-form-select-option>
              </template>
              <b-form-select-option v-for="tipoDoc in contabilitaTipoDocumentoOptions" :key="tipoDoc.id" :value="tipoDoc.id"> {{ tipoDoc.descrizioneTipoDocumento }} </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
            <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <configurazione-contabilita-causali-tipo-documenti-list-component ref="cmpConfigurazioneContabilitaCausaliTipoDocumentiListComponent" @editCausaleDocumento="onEditCausaleDocumento"></configurazione-contabilita-causali-tipo-documenti-list-component>
      <configurazione-contabilita-causale-documento-edit-modal-component
        ref="mdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent"
        @afterSave="onAfterSaveMdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent"
        @beforeSave="onBeforeSaveMdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent"
      ></configurazione-contabilita-causale-documento-edit-modal-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaCausaliTipoDocumentiListComponent from "../components/ConfigurazioneContabilitaCausaliTipoDocumentiListComponent.vue";
import ConfigurazioneContabilitaCausaleDocumentoEditModalComponent from "../components/ConfigurazioneContabilitaCausaleDocumentoEditModalComponent.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";

export default {
  mixins: [StruttureMixin, ContabilitaMixin],
  components: { SaPageLayout, ConfigurazioneContabilitaCausaliTipoDocumentiListComponent, ConfigurazioneContabilitaCausaleDocumentoEditModalComponent },
  data() {
    return {
      showModalLoading: false,
      pathResource: null,
      strutturaOptions: [],
      linkConfigurazioni: "/configurazionecontabilita",
      filtro: { codiceStruttura: null, idTipoDocumento: null },
    };
  },
  mounted() {
    this.struttureLoadData();
    this.contabilitaTipoDocumentoLoadData(null);
    let sessionStorage = window.sessionStorage;
    if (sessionStorage["filtroTipiDocumentoCausali"]) {
      this.filtro = JSON.parse(sessionStorage["filtroTipiDocumentoCausali"]);
    }
  },
  methods: {
    onChangeStruttura() {
      this.contabilitaTipoDocumentoLoadData(this.filtro.codiceStruttura);
    },
    onRefresh() {
      this.$refs.cmpConfigurazioneContabilitaCausaliTipoDocumentiListComponent.loadData();
    },
    onClickNuovoCausaleDocumento() {
      let me = this;
      me.$refs.mdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent.show({ id: null });
    },
    onBeforeSaveMdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent() {
      this.loadDataFilter();
    },
    onAfterSaveMdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent() {
      this.loadDataFilter();
    },
    onEditCausaleDocumento(item) {
      let me = this;
      me.$refs.mdlConfigurazioneContabilitaCausaleDocumentoEditModalComponent.show(item);
    },
    onSubmit() {
      this.loadDataFilter();
    },
    loadDataFilter() {
      let sessionStorage = window.sessionStorage;
      sessionStorage.setItem("filtroTipiDocumentoCausali", JSON.stringify(this.filtro));
      this.$refs.cmpConfigurazioneContabilitaCausaliTipoDocumentiListComponent.loadData();
    },
    onInputStrutture(v) {
      console.log(v);
    },
    onReset() {
      this.filtro.idTipoDocumento = null;
      this.filtro.codiceStruttura = null;
      this.loadDataFilter();
    },
  },
};
</script>

<style></style>
